<template>
  <div v-loading="loading" element-loading-spinner="el-icon-loading">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="d-flex align-items-center">
        <h6 class="m-0">{{ $l('form_header_sales') || '业务人员配置' }}</h6>
        <el-divider direction="vertical" v-if="!disabled" />
        <b-button
          v-if="!disabled"
          size="sm"
          variant="outline-success"
          @click="addSales"
          :disabled="enableEdit"
        >
          {{ $l('btn_addSales') || '新增人员' }}
        </b-button>
      </div>
      <div>
        <vxe-button
          size="mini"
          circle
          @click="getData()"
          :disabled="enableEdit"
        >
          <i class="vxe-button--icon vxe-icon--refresh" />
        </vxe-button>
      </div>
    </div>

    <div class="cust-sales-list">
      <el-form
        v-for="(form, index) in listSales"
        :key="index"
        ref="form"
        :model="form"
        :rules="rules"
        size="mini"
        :disabled="!form.enableEdit || disabled"
      >
        <div class="d-flex">
          <div>
            <div>
              <el-avatar
                shape="square"
                :src="form.memImgUrl || defaultAvatar"
              />
            </div>
            <div
              v-if="!enableEdit && !form.enableEdit && !disabled"
              class="text-center mt-2"
            >
              <el-tooltip
                effect="dark"
                :content="$l('INDEX.btn_tips_del') || '删除'"
                placement="bottom"
              >
                <i
                  class="el-icon-delete text-danger tool-btn"
                  @click="deleteSales(form)"
                />
              </el-tooltip>
              <el-tooltip
                effect="dark"
                :content="$l('INDEX.btn_tips_edit') || '编辑'"
                placement="bottom"
              >
                <i class="el-icon-edit tool-btn" @click="editSales(form)" />
              </el-tooltip>
            </div>
          </div>
          <div style="flex:1;padding-left: 16px;">
            <el-row :gutter="10">
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_userName') || '姓名'"
                  prop="userCode"
                >
                  <dict-select
                    v-if="!form.custBizTeamSetCode"
                    v-model="form.userCode"
                    :placeholder="$l('form_placeholder_user') || '请选择人员'"
                    url="/master/common/dict/baseUserSelect"
                    :selectedLabel.sync="form.userName"
                    clearable
                    filterable
                    size="mini"
                    @change="(code) => userChange(code, form)"
                  />
                  <el-input v-else v-model="form.userName" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$l('form_label_userPost') || '职务'">
                  <el-input v-model="form.userPost" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_mobileNumber') || '联系电话'"
                >
                  <el-input v-model="form.mobileNumber" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  :label="$l('form_label_emailAddress') || '邮件地址'"
                >
                  <el-input v-model="form.emailAddress" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_fixedTelephone') || '固定电话'"
                >
                  <el-input v-model="form.fixedTelephone" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$l('form_label_orgName') || '所属公司'">
                  <el-input v-model="form.orgName" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('form_label_depFullName') || '所属部门'"
                >
                  <el-input v-model="form.depFullName" readonly />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$l('form_label_bizTeamRoles') || '业务团队角色'"
                  prop="bizTeamRoles"
                >
                  <dict-select
                    v-model="form.bizTeamRoles"
                    :placeholder="
                      $l('form_placeholder_bizTeamRoles') ||
                        '请选择业务团队角色'
                    "
                    url="/digitalCenter/common/dict/system"
                    :body="{ dictType: 'bizTeamRoles' }"
                    clearable
                    filterable
                    size="mini"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  :label="$l('form_label_custCategory') || '负责客户品类'"
                >
                  <dict-select
                    v-model="form.custCategoryCodeList"
                    :placeholder="
                      $l('form_placeholder_custCategory') ||
                        '请选择负责客户品类'
                    "
                    url="/digitalCenter/master/customer/category/select"
                    :body="{ custCode: custCode || 'xxx' }"
                    clearable
                    filterable
                    multiple
                    size="mini"
                    ref="categorySelect"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="
                    $l('form_label_userResponsibilities') || '业务职责说明'
                  "
                >
                  <el-input
                    v-model="form.userResponsibilities"
                    :placeholder="
                      $l('form_placeholder_userResponsibilities') ||
                        '请输入业务职责说明'
                    "
                    type="textarea"
                    maxlength="200"
                    :rows="4"
                    show-word-limit
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>

        <div
          v-if="form.enableEdit && !disabled"
          class="my-2 d-flex justify-content-end"
        >
          <el-button size="small" @click="cancelEdit(index)">
            {{ $l('INDEX.btn_cancel') || '取消' }}
          </el-button>
          <el-button
            type="primary"
            size="small"
            @click="saveSales(form, index)"
          >
            {{ $l('INDEX.btn_save') || '保存' }}
          </el-button>
        </div>
      </el-form>

      <EmptyContent v-if="!listSales || !listSales.length" />
    </div>
  </div>
</template>

<script>
import { request } from '@/api/service'
import validate from '@/libs/util.validate'
import EmptyContent from '../empty-content'
import EditLoading from '@/mixins/edit-loading'
const initSales = {
  userPost: '',
  mobileNumber: '',
  emailAddress: '',
  fixedTelephone: '',
  orgName: '',
  depFullName: '',
  memImgUrl: '',
  enableEdit: true,
}
export default {
  components: { EmptyContent },
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      defaultAvatar: `${this.$baseUrl}image/theme/default/avatar.png`,
      loading: false,
      listSales: [],
      currSales: {},
      rules: {
        userCode: [
          {
            required: true,
            message: this.$l('form_placeholder_user') || '请选择人员',
            trigger: 'change',
          },
        ],
        bizTeamRoles: [
          {
            required: true,
            message:
              this.$l('form_placeholder_bizTeamRoles') || '请选择业务团队角色',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    enableEdit() {
      return this.listSales.some((item) => !!item.enableEdit)
    },
  },
  activated() {
    const categorySelect = this.$refs.categorySelect
    if (!categorySelect?.length) return
    categorySelect.forEach((select) => {
      try {
        select.init()
      } catch (e) {
        console.error(e)
      }
    })
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.custCode) return
      this.loading = true
      const res = await this.$api
        .masterCustomerBizTeamSetListByCustomerApi({ custCode: this.custCode })
        .catch(() => null)
      this.loading = false
      if (!res) return

      const data = res.body?.data || []
      this.listSales = data.map((item) => ({ ...item, enableEdit: false }))
    },
    addSales() {
      this.listSales.unshift({ ...initSales })
      this.currSales = null
    },
    async deleteSales({ custBizTeamSetCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBizTeamSetDelApi({ custBizTeamSetCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getData()
    },
    editSales(sales) {
      if (this.enableEdit) return
      this.currSales = JSON.parse(JSON.stringify(sales))
      sales.enableEdit = true
    },
    async saveSales(sales, index) {
      if (!(await validate.formValidate([this.$refs.form[index]]))) return

      if (this.loadingOpen()) return
      const res = await this.saveSalesApi(sales)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.getData()
    },
    saveSalesApi(sales) {
      const { custBizTeamSetCode } = sales
      if (!custBizTeamSetCode) {
        const params = { custCode: this.custCode, listUser: [sales] }
        return this.$api
          .masterCustomerBizTeamSetAddUserApi(params)
          .catch(() => null)
      }

      return this.$api
        .masterCustomerBizTeamSetUpdateApi(sales)
        .catch(() => null)
    },
    cancelEdit(index) {
      if (!this.currSales) {
        this.listSales.splice(index, 1)
      } else {
        this.$set(this.listSales, index, { ...this.currSales })
      }
    },
    async userChange(userCode, sales) {
      const getUserInfo = async () => {
        if (!userCode) return {}

        const res = await request({
          url: '/sys/user/detail',
          method: 'POST',
          data: { userCode },
        }).catch(() => null)
        if (!res) return
        return res.body || {}
      }

      const data = await getUserInfo()

      const {
        userPost,
        mobileNumber,
        emailAddress,
        fixedTelephone,
        orgName,
        depFullName,
        memImgUrl,
      } = data

      sales.userPost = userPost
      sales.mobileNumber = mobileNumber
      sales.emailAddress = emailAddress
      sales.fixedTelephone = fixedTelephone
      sales.orgName = orgName
      sales.depFullName = depFullName
      sales.memImgUrl = memImgUrl
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .tool-btn {
    font-size: 20px;
  }
  .el-textarea.is-disabled .el-textarea__inner {
    background-color: #fff;
  }
  .el-avatar {
    width: 80px;
    height: 80px;
    cursor: pointer;
  }
  .cust-sales-list {
    .el-form {
      background-color: #f4f6f9;
      padding: 16px;
      padding-bottom: 6px;
      border-radius: 5px;
      margin-bottom: 16px;
    }
    .el-form:last-child {
      margin-bottom: 0;
    }
    .no-data {
      color: #606266;
      font-size: 13px;
    }
  }
}
</style>
